import React, { useEffect, useState } from "react";
import { Backdrop, Box, CircularProgress, Stack } from "@mui/material";
import InboxHeader from "./Header/Header";
import { BACKEND_URL } from "../../helpers/variables";
import moment from "moment";
import { useLoaderData } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import Normal from "./Table/Normal";

// class BillProcessStatus(IntEnum):
//     DUPLICATE = 3
//     DELETE = 2
//     APPROVAL = 1
//     POSTING_FAILED = 0
//     OCR_FAILED = -1
//     EXTRACTION_FAILED = -2
//     INVALID_FILE = -3

export const statusMap = {
  0: { name: "Posting Failed", key: "POSTING_FAILED", color: "warning" },
  1: { name: "Posted", key: "APPROVAL", color: "success", hide: true },
  2: { name: "Deleted", key: "DELETE", color: "warning", hide: true },
  "-1": {
    name: "Extraction failed",
    key: "OCR_FAILED",
    color: "error",
    hide: true,
  },
  "-2": {
    name: "Extraction failed",
    key: "EXTRACTION_FAILED",
    color: "warning",
  },
  "-3": { name: "Invalid file", key: "INVALID_FILE", color: "error" },
  "-4": {
    name: "Extraction failed",
    key: "GROUPING_FAILED",
    color: "warning",
    hide: true,
  },
};

const InboxPage = () => {
  let { client_url, corporation_id } = useLoaderData();
  /**
   * @type {[{
   *   dateRange: Array<Date>,
   *   transaction: string,
   *   status: string
   *   stream_count: Number
   * } , React.Dispatch<React.SetStateAction<number>]}
   */
  const [filters, setFilters] = useState({
    dateRange: null,
    transaction: "Today",
    status: "all",
    vendor_name: "All",
    stream_count: 1,
  });

  const [bills, setBills] = useState(null);
  const [loading, setLoading] = useState(true);

  const updateFilter = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  useEffect(() => {
    getBills();

    return () => {
      if (eventSource) {
        eventSource.close();
      }
    };
  }, [filters]);

  let eventSource = null;

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  async function getBills() {
    console.log(timezone);
    setLoading(true);
    let { dateRange, vendor_name, status } = filters;
    let [startDate, endDate] = dateRange?.map((date) => date.toISOString()) || [
      null,
      null,
    ];

    let params = new URLSearchParams({
      status,
      corporation_id,
      client_url,
      vendor_name,
      ...(startDate && endDate && { start_date: startDate, end_date: endDate }),
    }).toString();

    eventSource = new EventSource(`${BACKEND_URL}/stream_bills?${params}`);

    eventSource.onmessage = (event) => {
      let bills = JSON.parse(event.data);
      setBills(bills);
      setLoading(false);
    };

    eventSource.onerror = () => {
      eventSource.close();
      setLoading(false);
    };
  }

  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Stack height={"100%"} gap={1}>
        <InboxHeader filters={filters} updateFilter={updateFilter} />
        <Box flexGrow={1} overflow={"auto"}>
          <Normal
            data={bills || []}
            refresh={() =>
              updateFilter("stream_count", filters.stream_count + 1)
            }
          />
        </Box>
      </Stack>

      <Backdrop open={loading} sx={{ zIndex: 3 }}>
        <CircularProgress />
      </Backdrop>
    </SnackbarProvider>
  );
};

export default InboxPage;
